export default "__VITE_ASSET__f86b7a99__"